<template>
    <div id="patients-portal-message">
        <div class="page-height">
            <MdTitleRegInfo
                v-if="$route.params.id"
                v-bind:RegistrationInfo="PatientTitle"
                v-bind:titlePrefix="$t('PPDbMessage.Title')"
                v-bind:titleRef="'titleElementMessage'"
                v-bind:patientCode="$route.params.id"
            />
            <MdTitle v-else v-bind:Text="$t('PPDbMessage.Title')" />
            <div
                class="alert alert-fill-warning d-flex align-items-center m-3"
                role="alert"
                v-if="isReadOnly"
            >
                <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                <div class="flex-grow-1">
                    <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                </div>
            </div>

            <b-row>
                <b-col sm="12" md="12">
                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group" dir="ltr">
                            <input
                                type="text"
                                class="form-control"
                                :dir="dirInput"
                                v-model="parameters.searchCriteria"
                                @keyup.enter="searchMessages"
                            />
                            <div class="input-group-append">
                                <MdButton
                                    v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="searchMessages"
                                >
                                </MdButton>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col lg="3" md="3" sm="12">
                    <MdSelect
                        v-bind:Label="$t('Shared.Status')"
                        v-bind:Options="statusOptions"
                        v-bind:FieldDescription="'text'"
                        v-bind:FieldCode="'value'"
                        v-bind:ModelArray="statusModel"
                        v-bind:Multiple="false"
                        :Input="changeDropDownStatus"
                    />
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdDateTime
                        :Label="$t('Shared.datefrom')"
                        :Model="parameters.dateFrom"
                        @input="parameters.dateFrom = $event"
                        :Id="'TestOrderDateFrom'"
                        :Type="'date'"
                        :isRequired="false"
                        :OnPressEnter="searchMessages"
                        :isConfirm="false"
                        :ReadOnly="false"
                        :isValid="isDateFromValid"
                    >
                    </MdDateTime>
                </b-col>
                <b-col lg="3" md="3" sm="12">
                    <MdDateTime
                        :Label="$t('Shared.dateTo')"
                        :Model="parameters.dateTo"
                        @input="parameters.dateTo = $event"
                        :Id="'TestOrderDateTo'"
                        :Type="'date'"
                        :isRequired="false"
                        :OnPressEnter="searchMessages"
                        :isConfirm="false"
                        :ReadOnly="false"
                        :isValid="isDateToValid"
                    >
                    </MdDateTime>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="12">
                    <div class="text-center text-md-right mt-3">
                        <button
                            v-on:click="searchMessages"
                            type="button"
                            class="btn btn-primary btn-login mx-2 pull-right"
                        >
                            {{ $t('Shared.Search') }}
                        </button>
                    </div>
                </b-col>
            </b-row>

            <MdTitle
                v-bind:Text="$t('Shared.SearchResult')"
                v-bind:isSubtitle="true"
                v-bind:Name="'T_TitleSearch'"
            />

            <b-row>
                <b-col class="col-12 mt-2">
                    <MdTable
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="showMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:VisibleEditIcon="false"
                        v-bind:FieldsDate="fieldsDateArr"
                        :onRowSelected="onRowSelected"
                        :onFiltered="onFiltered"
                        :pageChanged="pageChanged"
                        :perPageFunction="perPageFunction"
                        v-bind:VisibleViewIcon="!isReadOnly"
                        :viewIconEvent="viewMessageHandler"
                        :EmailNotificationNewFun="markAsHandler"
                        :EmailNotificationReadFun="markAsHandler"
                        v-bind:VisibleEmailNotificationNew="!isReadOnly"
                        v-bind:VisibleEmailNotificationRead="!isReadOnly"
                        :IsPatientPortalDashboard="true"
                        :isReadOnly="isReadOnly"
                    >
                        <template #cell-details="{ cell }">
                            {{ cell }}
                        </template>
                    </MdTable>
                </b-col>
            </b-row>
        </div>

        <div class="space-actions"></div>
        <div v-if="!$route.params.id" class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnpatientlist'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="gotoPatientPortal"
            />
        </div>

        <MDTextEditorDialog
            :visible="textEditorVisible"
            :value="textEditorValue"
            @close="closeTextEditorHandler"
            @ok="closeTextEditorHandler"
            :handlerOk="closeTextEditorHandler"
            :required="false"
            :buttonSaveHidden="true"
            :isReadOnly="true"
            :title="$t('PPDbMessage.Title')"
        >
        </MDTextEditorDialog>

        <patient-portal-notify
            :visible.sync="notifyVisible"
            :patientCodeList="selectedPatientCodeList"
            :notifyType="notifyType"
            :notifyTemplateList="
                notifyType === 'email' ? notifyEmailTemplateList : notifyTextTemplateList
            "
        />
    </div>
</template>

<script>
import moment from 'moment';
import Utils from '@/common/utils';
import PatientPortalMessageService from '@/services/patientPortalMessages.service';
import EnumService from '@/services/enum.service';
import { EventBus } from '@/event-bus.js';
import PatientPortalsService from '@/services/patientportals.service';
import PatientsPortalBase from './patientsPortalBase.vue';
import { patientsPortalStore } from './patientsPortalStore';
import PatientPortalNotify from './dialogs/patientPortalNotify.vue';

export default {
    name: 'PatientsPortalMessage',
    extends: PatientsPortalBase,
    components: {
        PatientPortalNotify
    },
    data() {
        return {
            RightMenuList: JSON.parse(JSON.stringify(EnumService.PatientsPortalSummaryItems)),
            items: [],
            totalRows: 0,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 10,
            fields: [
                {
                    key: 'shippingDate',
                    sortable: true,
                    label: this.$t('PPDbMessage.MessageDate'),
                    class: 'text-center'
                },
                {
                    key: 'firstName',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-left',
                    formatter: (_value, _key, item) => {
                        return `${item.firstName || ''} ${item.lastName || ''}`.trim();
                    }
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-left'
                },
                {
                    key: 'dob',
                    sortable: true,
                    label: this.$t('Shared.Dob'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'email',
                    sortable: true,
                    label: this.$t('Shared.Email'),
                    class: 'text-left'
                },
                {
                    key: 'cellPhone',
                    sortable: true,
                    label: this.$t('Shared.CellPhone'),
                    class: 'text-left'
                },
                {
                    key: 'dayPhone',
                    sortable: true,
                    label: this.$t('Shared.DayPhone'),
                    class: 'text-left'
                },
                {
                    key: 'nightPhone',
                    sortable: true,
                    label: this.$t('Shared.NightPhone'),
                    class: 'text-left'
                }
            ],
            fieldsDateArr: ['shippingDate', 'dob'],
            showMessageIsEmpty: false,
            parameters: {
                searchCriteria: '',
                dateFrom: null,
                dateTo: null,
                status: 'N'
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            isDateToValid: true,
            isDateFromValid: true,
            statusOptions: EnumService.NewReadAllOptions,
            statusModel: { value: 'N', text: this.$t('Shared.New') },
            textEditorVisible: false,
            textEditorValue: '',
            editableItem: null,
            isReadOnly: this.$store.state.isPatientPortalMessageEHRReadOnly
        };
    },
    methods: {
        gotoPatientPortal() {
            this.$router.push({ name: 'patients-portal' });
        },

        changeDropDownStatus(value) {
            this.parameters.status = value ? value.value : null;
            this.searchMessages();
        },

        viewMessageHandler(item) {
            this.textEditorVisible = true;
            this.textEditorValue = item.messageSend;
            this.editableItem = item;
        },

        closeTextEditorHandler() {
            this.textEditorVisible = false;

            if (this.editableItem.messageStatus === 'New') {
                this.markAsHandler(this.editableItem, 'R');
            }
        },

        async markAsHandler(item, status) {
            const data = {
                status: status === 'R' ? 'Read' : 'New'
            };
            await PatientPortalMessageService.changeMessagesStatus(item.id, data)
                .then(response => {
                    if (response.status == '200') {
                        this.showMessage(
                            this.$t('Msg.Success'),
                            this.$t('Shared.SavedSuccessfully'),
                            'success'
                        );

                        this.searchMessages();
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        onRowSelected() {},
        onFiltered() {},

        pageChanged(page) {
            this.currentPage = page;
            this.listingAsync();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.listingAsync();
        },

        searchMessages() {
            this.currentPage = 1;
            this.listingAsync();
        },

        async listingAsync() {
            const parameters = {
                PageSize: this.perPage,
                PageNumber: this.currentPage,
                PatientCodeList: this.$route.params.id ? [this.$route.params.id] : null,
                ...this.parameters
            };

            if (this.parameters.dateFrom && this.parameters.dateTo) {
                const result = Utils.validateDateRange(
                    this.parameters.dateFrom,
                    this.parameters.dateTo
                );

                if (!result.valid) {
                    this.isDateToValid = !result.fields.includes('toDate');
                    this.isDateFromValid = !result.fields.includes('fromDate');
                    this.showMessage(this.$tc('Msg.Error'), this.$t(result.message), 'error');
                    return;
                }
            } else {
                this.isDateToValid =
                    !this.parameters.dateTo || Utils.isValidDate(this.parameters.dateTo);
                this.isDateFromValid =
                    !this.parameters.dateFrom || Utils.isValidDate(this.parameters.dateFrom);

                if (!this.isDateToValid || !this.isDateFromValid) {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.CheckRedLabeledFields'),
                        'errorAutoHide'
                    );

                    return;
                }
            }

            await PatientPortalMessageService.getAll(parameters)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        const items = response.data;
                        items.forEach(data => {
                            data.VisibleNew = data.messageStatus === 'New';
                            data.VisibleRead = data.messageStatus !== 'New';
                            data.shippingDate = moment(data.shippingDate).format('ddd, ll');
                        });
                        this.items = items;
                        let headerString = response.headers['x-pagination'];
                        const header = JSON.parse(headerString);
                        this.totalRows = header.TotalCount;
                    }

                    this.showMessageIsEmpty = this.totalRows === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async loadPatientTitle(patientCode) {
            const infoList = await this.getInfoTitle(patientCode);
            if (infoList && infoList.length > 0) {
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0];
                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = `${firstname} ${lastname}`;
            }
        },

        async loadPortalPatient(patientCode) {
            const response = await PatientPortalsService.getAllDashboard({
                PageSize: 1,
                PageNumber: 1,
                PatientCodeList: [patientCode],
                status: null,
                portalStatus: null
            });
            if (response.status === 200 && response.data && response.data.length > 0) {
                this.selectedItems = response.data.filter(
                    x => x.patientCode.trim() === patientCode.trim()
                );
            }
        },

        enabledAllItems() {
            const item = this.selectedItems.length === 1 ? this.selectedItems[0] : null;
            this.RightMenuList.forEach(element => {
                let buttonEnabled = false;
                switch (element.value) {
                    case 'PPDB_CreateCredentials':
                        buttonEnabled =
                            item &&
                            item.portalStatus === 'Not Enrolled' &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email) &&
                            !!item.dob;
                        break;
                    case 'PPDB_ChangeUsername':
                    case 'PPDB_ChangePassword':
                        buttonEnabled = item && !Utils.isNullOrEmptyString(item.userName);
                        break;
                    case 'PPDB_PatientForms':
                    case 'PPDB_PatientContacts':
                    case 'PPDB_PatientClaims':
                    case 'PPDB_PatientInfo':
                    case 'PPDB_Summary':
                    case 'PPDB_ChangePatInfo':
                    case 'PPDB_Messages':
                    case 'PPDB_PatientList':
                        buttonEnabled = true;
                        break;
                    case 'PPDB_EmailToPatient':
                        buttonEnabled = this.isNotify('email');
                        break;
                    case 'PPDB_TextToPatient':
                        buttonEnabled = this.isNotify('text');
                        break;
                    default:
                        break;
                }
                element.ReadOnly = !buttonEnabled;
            });

            this.OptionsRightMenu.visible = false;
            this.OptionsRightMenu.btnPatientsPortalDashboardVisible = true;
            this.OptionsRightMenu.ItemsList = this.RightMenuList;
            this.OptionsRightMenu.active_el = this.getActiveElement();
            this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
        }
    },

    async mounted() {
        const patientCode = this.$route.params.id;

        if (!patientCode) {
            this.OptionsRightMenu.btnPatientsPortalDashboardVisible = false;
            this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
            await this.listingAsync();
            return;
        }

        await this.$nextTick();
        EventBus.$emit('loadMenu', patientCode);
        try {
            const stored = patientsPortalStore.selectedItem;
            if (stored && stored.patientCode.trim() === patientCode.trim()) {
                this.selectedItems = [stored];
                patientsPortalStore.selectedItem = null;
                await this.loadPatientTitle(patientCode);
            } else {
                await Promise.all([
                    this.loadPatientTitle(patientCode),
                    this.loadPortalPatient(patientCode)
                ]);
            }
        } catch (e) {
            // fall through to enabledAllItems with whatever data loaded
        }
        this.enabledAllItems();
        await this.listingAsync();
    }
};
</script>
